import {Component, inject, OnInit, signal, ViewChild} from '@angular/core';
import {FormsModule, NgForm} from '@angular/forms';
import {SharedCommonModule} from '../../shared/shared-common.module';
import {FileUploader, FileUploadModule} from 'ng2-file-upload';
import {NgIf} from '@angular/common';
import {ManufacturerRest} from '../../service/ManufacturerRest';
import {
  ActiveStatus,
  BusinessType,
  BusinessTypeArray,
  CertificateDto,
  ManufacturerDto,
  ManufacturerType,
  ManufacturerTypeArray,
  MapAddressResponse,
  PlaceOfDistribution,
  Sources
} from '../../../generated-model/model';
import {ConfirmDialogService} from '../../shared/commons/dialog/confirm-dialog/confirm-dialog.service';
import {ToastService} from '../../shared/commons/toast/toast-service';
import {filter} from 'rxjs/operators';
import {
  decimalPattern,
  emailPattern,
  integerPattern,
  noThaiCharacterPattern,
  pidPattern,
  postCodePattern,
  SsoUser, telephoneNumber, telephoneNumber2,
  updateFormAndValidity
} from '../../app.constants';
import {DigitOnlyModule} from '@uiowa/digit-only';
import {
  ProvinceAutocompleteComponent
} from '../../shared/components/province-autocomplete/province-autocomplete.component';
import {
  DistrictAutocompleteComponent
} from '../../shared/components/district-autocomplete/district-autocomplete.component';
import {
  SubDistrictAutocompleteComponent
} from '../../shared/components/subdistrict-autocomplete/sub-district-autocomplete.component';
import {PlaceOfDistributionRest} from '../../service/PlaceOfDistributionRest';
import {CustomErrorComponent} from '../../shared/custom-error.component';
import {Router} from '@angular/router';
import {NotFoundComponent} from '../../shared/not-found/not-found.component';
import {CertificateRest} from '../../service/CertificateRest';
import {IgnoreNullHttpParams} from '../../shared/Ignore-null-http-params';
import {AwsRest} from '../../service/AwsRest';
import {FileImageComponent} from '../../shared/components/file-image/file-image.component';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {HasAnyRoleDirective} from '../../auth/has-any-role.directive';
import {PinnedAddressService} from '../pinned-address/pinned-address.service';
import {PinnedAddressModalService} from '../pinned-address/pinned-address-modal.service';
import {DomSanitizer} from '@angular/platform-browser';
import {DigitsDotOnlyDirective} from '../../shared/digits-dot-only';
import {TelephoneNumberDirective} from '../../shared/telephone-number.directive';
import {ExistJuristicId} from '../../shared/validate/exist-juristic-id';

@Component({
  selector: 'app-manufacturer',
  standalone: true,
  imports: [
    FormsModule,
    SharedCommonModule,
    FileUploadModule,
    NgIf,
    DigitOnlyModule,
    ProvinceAutocompleteComponent,
    DistrictAutocompleteComponent,
    SubDistrictAutocompleteComponent,
    CustomErrorComponent,
    NotFoundComponent,
    FileImageComponent,
    HasAnyRoleDirective,
    DigitsDotOnlyDirective,
    TelephoneNumberDirective,
    ExistJuristicId
  ],
  templateUrl: './manufacturer.component.html',
  styleUrl: './manufacturer.component.scss'
})
export class ManufacturerComponent implements OnInit {
  protected businessTypeArray = BusinessTypeArray
  protected readonly businessType = BusinessType;
  protected readonly manufacturerTypeArray = ManufacturerTypeArray
  protected readonly manufacturerType = ManufacturerType
  protected readonly activeStatus = ActiveStatus;
  protected readonly sources = Sources;

  manufacturerRest = inject(ManufacturerRest)
  confirmDialogService = inject(ConfirmDialogService)
  toastService = inject(ToastService)
  placeOfDistributionRest = inject(PlaceOfDistributionRest)
  router = inject(Router)
  certificateRest = inject(CertificateRest)
  private oidcSecurityService = inject(OidcSecurityService)
  pinnedAddressService = inject(PinnedAddressService)
  pinnedAddressModalService = inject(PinnedAddressModalService)
  private sanitizer = inject(DomSanitizer);
  shouldResetFileComponent = false;

  item = signal<ManufacturerDto>({address: {}, contractUser: {}})
  selectedPlaceOfDistribution = signal<PlaceOfDistribution[]>([])
  isDisable = signal<boolean>(true)
  notEditable = signal<boolean>(false)
  haveCode: boolean = false;
  isShopEtc: boolean = false;
  uploader: FileUploader;
  placeOfDistribution = signal([] as PlaceOfDistribution[])
  certificates = signal([] as CertificateDto[])
  @ViewChild('form', {static: true}) form: NgForm

  loading = false;
  deleteManuFacIds: number[] = [];
  manuFacImages: File[] = [];
  awsService = inject(AwsRest)
  user: SsoUser;

  ngOnInit() {
    this.placeOfDistributionRest.getAll().subscribe(
      e => {
        this.placeOfDistribution.set(e)
        this.searchManufacturer()
      }
    )
  }

  searchManufacturer() {
    this.oidcSecurityService.userData$.subscribe(u => {
      this.user = u.userData as SsoUser
      this.manufacturerRest.findBySsoUserId()
        .subscribe(e => {
          if (e) {
            if (e.id) {
              console.log(e)
              this.haveCode = true
              this.isDisable.set(true)
              this.notEditable.set(true)
              this.selectedPlaceOfDistribution.set(e.placeOfDistributions)
              this.toggleShopEtc()
              this.searchCertificate()
            }
            this.item.set(e)
            if (!e.contractUser) {
              this.item().contractUser = {}
            }
          } else {
            this.isDisable.set(false)
            this.notEditable.set(false)
          }
        })
    })
  }

  toggleShopEtc() {
    if (this.selectedPlaceOfDistribution()?.find(e => e.id == 99)) {
      this.isShopEtc = true
    } else {
      this.isShopEtc = false
      this.item().placeOfDistributionOther = ''
    }
  }

  async upload() {
    try {
      const manuFacImageResult = await this.awsService.uploadMultiple(this.manuFacImages).toPromise();
      let existingImages = this.item().manufacturerImages || [];
      // กรองรูปที่ถูกลบออก - นี่คือส่วนสำคัญ!
      existingImages = existingImages.filter(img => !this.deleteManuFacIds.includes(img.id));

      this.item.update(val => ({
        ...val,
        manufacturerImages: [...existingImages, ...manuFacImageResult]
      }));
      return true;
    } catch (error) {
      console.error("Error uploading files:", error);
      this.toastService.showDangerWithMessage('เกิดข้อผิดพลาดในการอัพโหลดไฟล์');
      return false;
    }
  }

  save() {
    let valid = updateFormAndValidity(this.form)
    if (valid) {
      this.item().placeOfDistributions = this.selectedPlaceOfDistribution()
      this.item().website = this.item().website?.trim()
      try {
        if (this.upload()) {
          this.confirmDialogService.open({content: 'ยืนยันการบันทึกข้อมูล'}).pipe(filter(e => !!e))
            .subscribe({
              next: e => {
                const isNewManufact = !this.item().id
                this.manufacturerRest.save(this.item()).subscribe({
                  next: value => {
                    this.toastService.showSuccess('บันทึกข้อมูลสำเร็จ')
                    if (isNewManufact) {
                      this.oidcSecurityService.forceRefreshSession().subscribe(e => {
                        console.log("refresh session success", e?.userData)
                      })
                    }
                    this.manuFacImages = [];
                    this.deleteManuFacIds = [];

                    // ล้าง FileImageComponent
                    this.shouldResetFileComponent = true;
                    setTimeout(() => {
                      this.shouldResetFileComponent = false;
                    }, 100);

                    // จากนั้นจึงดึงข้อมูลใหม่
                    this.searchManufacturer();
                    this.loading = false; // ปิดสถานะ loading
                  }
                })
              }
            })
        }
      } catch (e) {
        console.error(e)
      }
    } else {
      this.toastService.showWarning('กรุณากรอกข้อมูลให้ครบถ้วน')
    }
  }

  onManufacturerTypeChange() {
    let businessTypeAll = BusinessTypeArray
    this.businessTypeArray = [...businessTypeAll]
    if (this.item().manufacturerType == 'JURISTIC_PERSON') {
      this.businessTypeArray = [...businessTypeAll.filter(e => e != 'FARMER')]
      this.item().businessType = undefined
    } else if (this.item().manufacturerType == 'NATURAL_PERSON') {
      this.businessTypeArray = [...businessTypeAll.filter(e => e != 'COMPANY')]
      this.item().businessType = undefined
    } else {
      this.item().businessType = undefined
    }
  }


  onPlaceChange($event: Event) {
    let target = $event.target as HTMLInputElement;
    let item = {id: +target.value}
    if (target.checked) {
      this.selectedPlaceOfDistribution().push(item)
    } else {
      this.selectedPlaceOfDistribution.set(this.selectedPlaceOfDistribution().filter(e => e.id != (+target.value)))
    }
    this.toggleShopEtc()
  }

  cancel() {
    // ล้างข้อมูลรูปภาพ
    this.manuFacImages = [];
    this.deleteManuFacIds = [];

    // ล้างข้อมูลใน item
    this.item.update(val => ({
      ...val,
      manufacturerImages: []
    }));

    // ทริกเกอร์การรีเซ็ต FileImageComponent
    this.shouldResetFileComponent = true;
    setTimeout(() => {
      this.shouldResetFileComponent = false;
    }, 100);

    // ดึงข้อมูลจาก server
    this.searchManufacturer();
  }

  onManufacturerImageChanged(event: { newFiles: File[], deletedFileIds: number[] }) {
    this.manuFacImages = event.newFiles;
    this.deleteManuFacIds = event.deletedFileIds;
    // อัปเดต item หรือตัวแปรที่เก็บข้อมูลรูปภาพ
    if (this.item().manufacturerImages) {
      const updatedImages = this.item().manufacturerImages.filter(
        img => !event.deletedFileIds.includes(img.id)
      );
      this.item.update(val => ({
        ...val,
        manufacturerImages: updatedImages
      }));
    }
  }

  searchCertificate(page: number = 1) {
    let param = IgnoreNullHttpParams.fromObject({certificateGroup: "PRODUCTION", active: "A"})
      .set("page", page - 1)
      .set("size", 100)
      .set("sort", "id,desc")
    this.certificateRest.search(param).subscribe(
      data => {
        this.certificates.set(data.content)
      }
    )
  }

  edit() {
    this.isDisable.set(false)
  }

  checked(place: PlaceOfDistribution): boolean {
    return this.selectedPlaceOfDistribution().some(e => e.id == place.id)
  }

  fillContractUser() {
    this.item().contractUser.fullName = [this.user.given_name, this.user.family_name].filter(Boolean).join(' ')
    console.log(this.user.family_name)
    console.log(this.item().contractUser.fullName)
    this.item().contractUser.email = this.user.email
    this.item().contractUser.telephoneNo = this.user.phone_number
    console.log(this.item().contractUser)
  }

  openModalPinnedAddress() {
    this.pinnedAddressModalService.open(+this.item().latitude, +this.item().longitude, this.item().address?.province?.name, this.item().address?.district?.name).subscribe({
      next: value => {
        if (value != 'Cross click') {
          this.setAddress(value)
        }
      }
    })
  }

  getCurrentPosition() {
    this.confirmDialogService.open({content: 'ยืนยันการเลือกพิกัดตำแหน่งปัจจุบัน'}).pipe(filter(e => !!e)).subscribe(
      () => {
        this.pinnedAddressService.getCurrentPosition().subscribe({
          next: value => {
            this.setAddress(value)
          }
        })
      }
    )
  }

  setAddress(address: MapAddressResponse) {
    this.item().latitude = address.latitude?.toString()
    this.item().longitude = address.longitude?.toString()
  }

  protected readonly emailPattern = emailPattern;
  protected readonly pidPattern = pidPattern;

  onProvinceChange() {
    this.item().address.district = undefined
    this.item().address.subDistrict = undefined
  }

  onDistrictChange() {
    this.item().address.subDistrict = undefined
  }

  protected readonly postCodePattern = postCodePattern;
  protected readonly integerPattern = integerPattern;
  protected readonly decimalPattern = decimalPattern;
  protected readonly telephoneNumber2 = telephoneNumber2;
  protected readonly noThaiCharacterPattern = noThaiCharacterPattern;
}
